<template>
  <div class="onboarding-card">
    <img src="/images/onboarding/logo-terrazon.svg" alt="Terrazon" class="ob-logo-img d-block mx-auto" />
    <p class="ob-subtitle text-center mb-4">Hola, {{ primerNombre }}</p>

    <p class="ob-question">¿Cómo es tu casa soñada?</p>
    <textarea
      v-model="descripcionPropiedad"
      class="form-control ob-input mb-3"
      rows="3"
      placeholder="Describe tu sueño aquí... (Ej: 3 habitaciones, piscina, zona norte de Mérida, 2 estacionamientos)"
    ></textarea>

    <p class="ob-question">¿Presupuesto máximo (MXN)?</p>
    <input
      v-model="presupuestoMostrado"
      type="text"
      inputmode="numeric"
      class="form-control ob-input mb-3"
      placeholder="Monto total"
      @input="onPresupuestoInput"
    />

    <div class="ob-metodo-pago mb-4">
      <label
        v-for="opcion in metodosPago"
        :key="opcion.value"
        class="ob-metodo-opcion"
        :class="{ activo: metodoPago === opcion.value }"
      >
        <input v-model="metodoPago" type="radio" :value="opcion.value" name="metodo_pago" />
        {{ opcion.label }}
      </label>
    </div>

    <p v-if="errorMsg" class="ob-error">{{ errorMsg }}</p>

    <button
      type="button"
      class="btn ob-btn-primary w-100"
      :disabled="!esValido || loading"
      @click="guardar"
    >
      <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
      ANALIZAR MERCADO
    </button>

    <p class="ob-footer">GRUPO TERRAZON SAPI DE CV</p>
  </div>
</template>

<script>
export default {
  name: 'PantallaPerfilamiento',
  props: {
    nombre: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    errorMsg: { type: String, default: '' },
  },
  data() {
    return {
      descripcionPropiedad: '',
      presupuestoMax: '',
      presupuestoMostrado: '',
      metodoPago: '',
      metodosPago: [
        { value: 'recurso_propio', label: 'Recurso propio' },
        { value: 'credito_bancario', label: 'Crédito bancario' },
        { value: 'ambos', label: 'Ambos' },
      ],
    };
  },
  computed: {
    primerNombre() {
      return (this.nombre || '').split(' ')[0] || '';
    },
    esValido() {
      return (
        this.descripcionPropiedad.trim().length > 0 &&
        Number(this.presupuestoMax) > 0 &&
        !!this.metodoPago
      );
    },
  },
  methods: {
    onPresupuestoInput(e) {
      const soloDigitos = e.target.value.replace(/\D/g, '');
      this.presupuestoMax = soloDigitos;
      this.presupuestoMostrado = soloDigitos ? Number(soloDigitos).toLocaleString('es-MX') : '';
    },
    guardar() {
      if (!this.esValido || this.loading) return;
      this.$emit('guardar', {
        descripcion_propiedad: this.descripcionPropiedad.trim(),
        presupuesto_max: Number(this.presupuestoMax),
        metodo_pago: this.metodoPago,
      });
    },
  },
};
</script>
